module.exports = new Promise(function (resolve, reject) {
    var __webpack_error__ = new Error();

    if (typeof window["xsollaMoney"] !== 'undefined') {
      return resolve();
    }

    __webpack_require__.l(
      window["xsollaMoneyRemoteUrl"] + '/remote-entry-xsolla-money.js',
      function (event) {
        if (typeof window["xsollaMoney"] !== 'undefined') {
           return resolve();
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "xsollaMoney",
    );
  }).then(function(){
    var proxy = {
      get: window["xsollaMoney"].get,
      init: window["xsollaMoney"].init
    }
    return proxy
  }).catch(function(e) {
    console.error('xsollaMoney', e);
    let newProxy = {
      get: (module, scope) => () => [],
      init: () => {}
    }
    return(newProxy);
  });